import {store} from "./store";

export const useProfileNavigation = store;
